import React, {Component, Fragment} from 'react';
import ListaTabla from './Includes/ListaTabla';
import ModalSaekoAlumnosPagos from './Includes/ModalSaekoAlumnosPagos';

import {SaekoAlumnosService} from '../../../services/SaekoAlumnosService/SaekoAlumnosService';
import {FieldsJs} from "../../../settings/General/General";
import {ReactLocalStorageService} from '../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import VistaVacia from "../../Include/VistaVacia/VistaVacia";

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../settings/IntegrationNotistack/IntegrationNotistack";
import {BotonActualizarLista, BotonExportarListaExcel, BotonExportarListaPDF, CabeceraTituloPdfExcelLista} from "../../Include/MiniComponents/GlobalComponent";
import Paginacion from "../../Include/Paginacion/Paginacion";
import {CatService} from "../../../services/_Cat/CatService/CatService";
import FiltrosSaekoAlumnosPagos from "./Includes/FiltrosSaekoAlumnosPagos";


class SaekoAlumnosPagos extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor() {
		super();
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		this.state = {
			listar_cat_cliente: [],
			listar_cat_saeko_lead: [],
			listar_cat_saeko_tag: [],
			
			filtro: {},
			
			paginacion: {
				total: null,
				page: 1,
				limit: this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			},
		};
		
		this.Listar();
		this.ListarSaekoLead();
		this.ListarSaekoTag();
	}
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	RefreshList = () => {
		this.Listar();
	};
	
	
	HandleFiltro = (filtro) => {
		this.setState({
			filtro: filtro
		});
	};
	
	DefaultNumPag = () => {
		let Cfg = Number(ReactLocalStorageService.get('Cfg')) === 10 || FieldsJs.Field(ReactLocalStorageService.get('Cfg')) ? 12 : ReactLocalStorageService.get('Cfg') || {};
		return Cfg.paginacion_numero_registro ? Number(Cfg.paginacion_numero_registro) : 12;
	};
	
	DefaultRangos = () => {
		let Cfg = Number(ReactLocalStorageService.get('Cfg')) === 10 || FieldsJs.Field(ReactLocalStorageService.get('Cfg')) ? 12 : ReactLocalStorageService.get('Cfg') || {};
		let rangos = [6, 12, 24, 36];
		if (FieldsJs.Array(Cfg.paginacion_rangos)) {
			rangos = Cfg.paginacion_rangos;
		}
		return rangos;
	};
	
	ListarSaekoLead = () => {
		return new Promise((resolve, reject) => {
			CatService.ListSaekoLead().then((response) => {
				this.setState({
					listar_cat_saeko_lead: response.data
				});
				resolve(response);
			});
		});
	};
	
	ListarSaekoTag = () => {
		return new Promise((resolve, reject) => {
			CatService.ListSaekoTag().then((response) => {
				this.setState({
					listar_cat_saeko_tag: response.data
				});
				resolve(response);
			});
		});
	};
	
	Listar = () => {
		SaekoAlumnosService.ListarPagos(this.state.filtro, this.state.paginacion).then((response) => {
			this.setState({
				listar_cat_cliente: response.data,
				
				paginacion: {
					total: response.paginacion.total,
					page: response.paginacion.page,
					limit: response.paginacion.limit,
					rangos: this.DefaultRangos()
				}
			});
		}).catch((error) => {
			this.setState({
				listar_cat_cliente: []
			});
			this.showSnackBars('error', error.mensaje);
		});
	};
	
	
	AplicarPaginacion = (data) => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: data.page || paginacion.page || null,
				limit: data.limit || paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	AplicarFiltros = () => {
		let paginacion = this.state.paginacion;
		this.setState({
			paginacion: {
				total: paginacion.total || null,
				page: 1,
				limit: paginacion.limit || this.DefaultNumPag(),
				rangos: this.DefaultRangos()
			}
		});
		setTimeout(() => this.Listar());
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				
				<CabeceraTituloPdfExcelLista
					titulo={'ALG Finanzas'}
					/*botonPDF={
						<Fragment>
							{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
								<BotonExportarListaPDF onClick={() => {
								
								}}/>
							) : ''}
						</Fragment>
					}
					botonEXCEL={
						<Fragment>
							{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
								<BotonExportarListaExcel onClick={() => {
								
								}}/>
							) : ''}
						</Fragment>
					}*/
					botonLISTA={
						<Fragment>
							<BotonActualizarLista onClick={() => {
								this.Listar();
							}}/>
						</Fragment>
					}
				/>
				<FiltrosSaekoAlumnosPagos
					AplicarFiltros={this.AplicarFiltros}
					HandleFiltro={this.HandleFiltro}
					showSnackBars={this.showSnackBars}
					catSaekoLead={this.state.listar_cat_saeko_lead}
					catSaekoTag={this.state.listar_cat_saeko_tag}
				/>
				
				<div className={'form margin-30-B'} style={{marginTop: '20px'}}>
					
					{this.state.listar_cat_cliente.length > 0 ? (
						<Fragment>
							<ListaTabla
								lista={this.state.listar_cat_cliente}
								RefreshList={this.RefreshList}
								showSnackBars={this.showSnackBars}
							/>
							<Paginacion
								total={this.state.paginacion.total}
								page={this.state.paginacion.page}
								limit={this.state.paginacion.limit}
								rangos={this.state.paginacion.rangos}
								onClick={(data) => this.AplicarPaginacion(data)}
							/>
						</Fragment>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<ModalSaekoAlumnosPagos
					tipo={'add'}
					item={{}}
					RefreshList={this.RefreshList}
					showSnackBars={this.showSnackBars}
				/>
			
			</div>
		);
	}
}

SaekoAlumnosPagos.propTypes = {};

export default IntegrationNotistack(SaekoAlumnosPagos);
